import { LoadingOutlined } from "@ant-design/icons";
import { Spin } from "antd";
import { LoadingProps } from "./types";

export const Loading = (props: LoadingProps) => {
	return <Spin indicator={<LoadingOutlined spin style={{ fontSize: 24 }} />} tip={props.tip} />;
};
